<template>
  <div class="export-field">
    <div class="status-box">
      <a href="javascript:void(0);" class="status-button" @click="showConfirmationModal">
        {{ buttonText }}
      </a>
    </div>

    <!-- Password Modal -->
    <div class="modal__wrapper" v-if="showPasswordField">
      <div class="modal__screen" @click.prevent="closeConfirmationModal"></div>
      <div class="modal">
        <div class="modal__header">
          <a href="#" class="modal__close" @click.prevent="closeConfirmationModal">
            <i class="fa fa-times"></i>
          </a>
        </div>
        <div class="modal__body">
          <p>Please enter password to export</p>
          <input type="password" v-model="enteredPassword" placeholder="Enter password for export">
          <p>
            <button class="button button-primary--small" @click.prevent="validatePassword">Submit Password</button>
            <button class="button button-secondary--small" @click.prevent="closeConfirmationModal">Cancel</button>
          </p>
          <p v-if="modalMessage" :style="{ color: isError ? 'red' : 'green' }">{{ modalMessage }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    buttonText: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      showPasswordField: false,
      enteredPassword: '',
      modalMessage: '',
      isError: false,
      validPassword: 'pT8#xA!w9Qz@4uLs'
    };
  },
  methods: {
    showConfirmationModal() {
      this.enteredPassword = '';
      this.modalMessage = '';
      this.isError = false;
      this.showPasswordField = true;
    },

    closeConfirmationModal() {
      this.showPasswordField = false;
      this.enteredPassword = '';
      this.modalMessage = '';
      this.isError = false;
    },

    validatePassword() {
      axios.get('/api/v1/excel-password/validate', {
        params: { password: this.enteredPassword },
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json',
        }
      })
        .then(response => {
          if (response.data.success) {
            this.modalMessage = 'Password correct! Exporting...';
            this.isError = false;
            setTimeout(() => {
              this.closeConfirmationModal();
              this.triggerExport();
            }, 3000);
          } else {
            this.modalMessage = response.data.message || 'Incorrect password. Please try again.';
            this.isError = true;
            setTimeout(() => {
              this.modalMessage = '';
            }, 3000);
          }
        })
        .catch(error => {
          this.modalMessage = 'An error occurred. Please try again.';
          this.isError = true;
          setTimeout(() => {
            this.modalMessage = '';
          }, 3000);
          console.error(error);
        });
    },

    showExportMessage() {
      const exportMessageElement = document.getElementById('exportMessage');
      if (exportMessageElement) {
        exportMessageElement.style.display = 'block';
        setTimeout(() => {
          exportMessageElement.style.display = 'none';
        }, 3000);
      } else {
        console.error("Element with ID 'exportMessage' not found.");
      }
    },

    triggerExport() {
      this.showExportMessage();
      const exportUrl = new URL(window.location.href);
      let fieldName = this.fieldName ? this.fieldName : 'exportExcel';
      exportUrl.searchParams.set(fieldName, 'true');
      console.log('Export URL:', exportUrl.toString());
      window.location.href = exportUrl.toString();
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/ExportField.vue